
import React from "react";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";

interface QuizLoadingProps {
  message?: string;
  size?: "sm" | "md" | "lg";
}

const QuizLoading: React.FC<QuizLoadingProps> = ({ 
  message = "Loading quiz...", 
  size = "md" 
}) => {
  return (
    <div className="flex justify-center items-center min-h-[200px] p-6">
      <div className="bg-card border rounded-lg p-6 shadow-sm w-full max-w-md text-center">
        <LoadingSpinner 
          message={message}
          size={size}
          centered={true}
          pulse={true}
          variant="primary"
          className="mb-2"
        />
        <p className="text-xs text-muted-foreground mt-4 animate-pulse">
          Preparing your quiz experience...
        </p>
      </div>
    </div>
  );
};

export default QuizLoading;
